import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-051a670d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "d-flex flex-column flex-grow-1 scrollable-parent"
};
const _hoisted_2 = {
  class: "d-flex flex-column align-items-center pt-5 mt-5"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/logo.svg",
  alt: "logo",
  class: "logo"
}, null, -1));
const _hoisted_4 = {
  class: "card-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_alert = _resolveComponent("app-alert");
  const _component_login_card = _resolveComponent("login-card");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_app_alert), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_login_card, {
    scrollable: $props.scrollable
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["scrollable"])])])])], 64);
}